import { render, staticRenderFns } from "./ImageBlob.vue?vue&type=template&id=27a8f89e&scoped=true"
import script from "./ImageBlob.vue?vue&type=script&lang=js"
export * from "./ImageBlob.vue?vue&type=script&lang=js"
import style0 from "./ImageBlob.vue?vue&type=style&index=0&id=27a8f89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a8f89e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
